import classnames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { Node_Type } from "./../../ricos-types/index.js";
import { getLangDir } from "./../../wix-rich-content-common/index.js";
import Card from "../components/Card.js";
import { convertDuration } from "../convertDuration.js";
import { ROOT } from "../data-hooks.js";
import styles from "../statics/styles/widget-scss.js";
import { VERTICAL_EMBED_TYPE } from "../types.js";
const VerticalEmbedViewer = ({
  settings,
  componentData,
  helpers,
  nodeId
}) => {
  const { t, locale } = useContext(RicosContext);
  const onClick = () => helpers.onViewerAction?.(VERTICAL_EMBED_TYPE, "Click", componentData.type, nodeId, {
    type: Node_Type.APP_EMBED,
    appEmbedData: componentData
  });
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames(styles.card, { [styles.slimLayout]: settings.slimLayout }),
        "data-hook": ROOT,
        onClick
      },
      /* @__PURE__ */ React.createElement(
        Card,
        {
          url: settings.changeBaseUrl ? settings.changeBaseUrl(componentData.url) : componentData.url,
          title: componentData.name,
          image: componentData.image,
          buttonText: t(
            {
              PRODUCT: "VerticalEmbed_Products_Button",
              EVENT: "VerticalEmbed_Events_Button",
              BOOKING: "VerticalEmbed_Bookings_Button"
            }[componentData.type]
          ),
          t,
          direction: getLangDir(locale),
          disabled: settings.disabled,
          subtitleInfo: componentData.type === "EVENT" && componentData.eventData ? {
            leftSubtitle: componentData.eventData.scheduling,
            rightSubtitle: componentData.eventData.location
          } : componentData.type === "BOOKING" && componentData.bookingData ? {
            leftSubtitle: convertDuration(componentData.bookingData.durations, t),
            rightSubtitle: void 0
          } : void 0
        }
      )
    )
  );
};
export {
  VerticalEmbedViewer
};
//# sourceMappingURL=vertical-embed-viewer.js.map
